import React from 'react';
import warning from '../../assets/images/warning.png';
import vector from '../../assets/images/Vector.png';
import frame from '../../assets/images/Frame.png';

const WarningBox = ({ statusMessage, islistPage, onClose }) => {
  return (
    <div className='InactivityWarning d-flex align-items-center'>
      <div className='d-flex align-items-center'>
    
        <img src={vector} width="24px" height="24px"/>
      
      <span style={{ marginLeft: '10px',fontSize:"18px" }}>
        {statusMessage}
      </span>
      </div>
      {islistPage && <img src={frame} style={{cursor:"pointer"}} width="24px" height="24px" onClick={onClose} />}
    </div>
  );
};

export default WarningBox;




